import { useNavigate } from "react-router-dom";
import { useUser } from "./useUser";
import { isInternal } from "../utils";

export const useBrandDetailLink = () => {
  const navigate = useNavigate();
  const { role } = useUser();
  const enabled = isInternal(role);

  const goToBrand = (id?: number | string | null) => {
    if (!enabled || id == null) return;
    navigate(`/brands/${id}/details`);
  };

  return { enabled, goToBrand };
};
